import { createFileRoute } from '@tanstack/react-router'
import { ReluxWizard } from '@/features/relux/wizard/wizard'

export const Route = createFileRoute('/_app/reluxes/draft/$draftId')({
  validateSearch: (s: Record<string, unknown>): { step?: string } => ({
    step: typeof s.step === 'string' ? s.step : undefined,
  }),
  component: Draft,
})

function Draft() {
  const { draftId } = Route.useParams()
  const { step } = Route.useSearch()
  const { me } = Route.useRouteContext()
  return <ReluxWizard key={draftId} draftId={draftId} step={step} me={me} />
}
